import { defineComponent as _defineComponent } from 'vue';
import { computed, toRef, watch } from "vue";
import { useJobStore } from "@/stores/jobStore";
import { useMappingJobs } from "./handlesMappingJobs";
import JobSelection from "./JobSelection.vue";
import JobParameters from "@/components/JobParameters/JobParameters.vue";
import ToolLinkPopover from "@/components/Tool/ToolLinkPopover.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'JobParameters',
    props: {
        jobId: { default: undefined },
        implicitCollectionJobsId: { default: undefined },
        param: { default: undefined },
        title: { default: undefined },
        footer: { default: undefined }
    },
    setup(__props) {
        const props = __props;
        const jobStore = useJobStore();
        const toolId = computed(() => {
            if (targetJobId.value) {
                return jobStore.getJob(targetJobId.value)?.tool_id;
            }
            return undefined;
        });
        const toolVersion = computed(() => {
            if (targetJobId.value) {
                return jobStore.getJob(targetJobId.value)?.tool_version;
            }
            return undefined;
        });
        const jobIdRef = toRef(props, "jobId");
        const implicitCollectionJobsIdRef = toRef(props, "implicitCollectionJobsId");
        const { selectJobOptions, selectedJob, targetJobId } = useMappingJobs(jobIdRef, implicitCollectionJobsIdRef);
        async function init() {
            if (targetJobId.value) {
                jobStore.fetchJob(targetJobId.value);
            }
        }
        watch(targetJobId, () => {
            init();
        }, { immediate: true });
        return { __sfc: true, props, jobStore, toolId, toolVersion, jobIdRef, implicitCollectionJobsIdRef, selectJobOptions, selectedJob, targetJobId, init, JobSelection, JobParameters, ToolLinkPopover };
    }
});
